import { render, staticRenderFns } from "./SurveySubmissionsDetail.vue?vue&type=template&id=2c75f26a&scoped=true"
import script from "./SurveySubmissionsDetail.vue?vue&type=script&lang=js"
export * from "./SurveySubmissionsDetail.vue?vue&type=script&lang=js"
import style0 from "./SurveySubmissionsDetail.vue?vue&type=style&index=0&id=2c75f26a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c75f26a",
  null
  
)

export default component.exports